// extracted by mini-css-extract-plugin
export default {"companyHolder":"CompanyForm_companyHolder__zocx3","bgColor":"CompanyForm_bgColor__Dlfxz"};